import _jaTranslation from './ja.json';

const translation = {
    ..._jaTranslation,
};

export default translation;